var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalTerms',{ref:"modal",attrs:{"gtc":_vm.gtc,"checkbox-text":_vm.checkboxText,"is-creating":_vm.isCreating,"title":_vm.title,"showDownloadLink":_vm.showDownloadLink},on:{"accept":_vm.accept,"downloadExcel":_vm.downloadExcel}})
}
var staticRenderFns = []

export { render, staticRenderFns }